const getList = ({ LANG = {}, pid }) => {
  const config = {
    12: {
      list: [
        {
          key: 'edtion',
          abbr: LANG['product.personalized.modalMenu1'],
          title: LANG['product.personalized.modalTitle1'],
          cids: [972, 973, 974, 976, 994, 975, 1000, 1001],
          commodities: null,
        },
        {
          key: 'lens',
          abbr: LANG['product.personalized.modalMenu2'],
          title: LANG['product.personalized.modalTitle2'],
          cids: [981, 992, 982],
          filters: {
            981: [973, 974, 1000], // 360镜头 - 数组内套餐可见
            982: [972, 973, 975, 976, 994, 1000], // leica镜头
            992: [975, 974, 994, 976, 1000, 1001], // 4k镜头
          },
          commodities: null,
          filterCommidities: {}, // {commodities:[],totalPage:0,}
        },
        {
          key: 'basic',
          abbr: LANG['product.personalized.modalMenu3'],
          title: LANG['product.personalized.modalTitle3'],
          cids: [993, 988, 978, 977, 1047, 979, 989, 1128, 987, 1058, 995, 1002, 1310, 481, 1134, 1045, 411, 351, 851],
          filters: {
            988: [972, 973, 974, 976, 994, 975, 1001],
            978: [974, 1001, 1000],
            977: [972, 973, 1000],
            1047: [972, 975, 1001, 1000],
            987: [972, 975, 1000, 1001],
            995: [972, 976, 994, 975, 1000, 1001],
            411: [973, 974, 976, 994, 975],
            351: [973, 974, 976, 994],
            851: [973, 974, 976, 994],
          },
          commodities: null,
          filterCommidities: {},
        },
        {
          key: 'sport',
          abbr: LANG['product.personalized.modalMenu4'],
          title: LANG['product.personalized.modalTitle3'],
          cids: [391, 1094, 202, 1125, 292, 332, 212, 281, 262, 271, 312, 222],
          commodities: null,
        },
      ],
    },
    // 13: {
    //   list: [
    //     {
    //       key: 'edition',
    //       abbr: LANG['product.personalized.modalMenu1'],
    //       title: LANG['product.personalized.modalTitle1'],
    //       cids: [1164, 1176, 1181, 1316, 1168, 1174, 1179, 1182, 1180],
    //       commodities: null,
    //     },
    //     {
    //       key: 'basic',
    //       abbr: LANG['product.personalized.modalMenu3'],
    //       title: LANG['product.personalized.modalTitle3'],
    //       cids: [
    //         1158, 1207, 1171, 993, 181, 851, 1246, 1173, 183, 1162, 351, 1163, 1212, 1258, 1310, 1161, 1165, 1444, 1134,
    //         1159,
    //       ],
    //       filters: {
    //         1171: [1164, 1168, 1174, 1179],
    //         993: [1164, 1168, 1174, 1179],
    //         181: [1164, 1168, 1174, 1180, 1181, 1316, 1179, 1182],
    //         851: [1164, 1168, 1174, 1176, 1182],
    //         183: [1164, 1168, 1174, 1180, 1181, 1316, 1179, 1182],
    //         1162: [1164, 1168, 1174, 1180, 1176, 1181, 1316, 1182],
    //         1163: [1164, 1168, 1174, 1180, 1176, 1181, 1316, 1179],
    //         1310: [1180, 1176, 1181, 1316, 1179, 1182],
    //         1161: [1164, 1168, 1174, 1180, 1176, 1181, 1316],
    //         1444: [1176, 1316, 1182],
    //         1134: [1180, 1176, 1181, 1179, 1182],
    //         1159: [1180, 1176, 1181, 1316, 1179, 1182],
    //       },
    //       commodities: null,
    //       filterCommidities: {},
    //     },
    //     {
    //       key: 'sport',
    //       abbr: LANG['product.personalized.modalMenu4'],
    //       title: LANG['product.personalized.modalTitle3'],
    //       cids: [391, 1094, 202, 1125, 292, 332, 212, 281, 262, 271, 312, 222],
    //       commodities: null,
    //       filterCommidities: {},
    //     },
    //   ],
    // },
    15: {
      list: [
        {
          key: 'edition',
          abbr: LANG['product.personalized.modalMenu1'],
          title: LANG['product.personalized.modalTitle1'],
          cids: [1742, 1747, 1749],
          commodities: null,
        },
        {
          key: 'lens',
          abbr: LANG['product.personalized.modalMenu2'],
          title: LANG['product.personalized.modalTitle2'],
          cids: [982, 1730],
          filters: {
            982: [1742, 1747], // 徕卡镜头
            1730: [1747, 1749], // 新全景镜头
          },
          commodities: null,
          filterCommidities: {},
        },
        {
          key: 'basic',
          abbr: LANG['product.personalized.modalMenu3'],
          title: LANG['product.personalized.modalTitle3'],
          cids: [1737, 1258, 1494, 978, 1736, 1047, 995, 1774, 1792, 1693, 1754, 1734, 411, 183, 851, 1344],
          filters: {
            1737: [1742, 1747, 1749],
            1258: [1742, 1747, 1749],
            1494: [1742],
            978: [1749],
            1736: [1742, 1747],
            1047: [1742],
            995: [1742],
            1774: [1742, 1747, 1749],
            1792: [1742, 1747, 1749],
            1693: [1742, 1747, 1749],
            1754: [1742, 1747, 1749],
            1734: [1742, 1747, 1749],
            411: [1742, 1747, 1749],
            183: [1742, 1747, 1749],
            851: [1742, 1747, 1749],
            1344: [1742, 1747, 1749],
          },
          commodities: null,
          filterCommidities: {},
        },
        {
          key: 'sport',
          abbr: LANG['product.personalized.modalMenu4'],
          title: LANG['product.personalized.modalTitle3'],
          cids: [1094, 202, 391, 1567, 292, 332, 212, 281, 262, 271, 312, 222],
          commodities: null,
        },
      ],
    },
  };
  return config[pid];
};

function enabled({ pid }) {
  return !!getList({ pid });
}

const getOrdinalNumberText = ({ LANG, index }) => {
  let text = '';
  try {
    const ordinalNumber = JSON.parse(LANG['product.personalized.ordinalNumber']);
    text = ordinalNumber[0][index];
  } catch (e) {
    console.error(e);
  }
  return text;
};

const ic = {
  iCare: 'https://static.insta360.com/assets/storage/20200102/45599ec0e1e21c9280e79c49a22969d6/Insta360_Care_2x.png',
  iAdd: 'https://static.insta360.com/assets/storage/20200102/70614cf2408b798d3d60fd3e06fdb37c/Add_2x.png',
  iRemove: 'https://static.insta360.com/assets/storage/20200102/547480fb9226fb2ce0ba053a2c24f141/Delete_2x.png',
  iBox: 'https://static.insta360.com/assets/storage/20200102/d176fad4d020f14046095f0459e14d75/box48_2x.png',
  iCloseBlack: 'https://static.insta360.com/assets/storage/20200102/f51d98fa86950118fc696772435bcd29/Close_h_2x.png',
  iLogo4K: 'https://static.insta360.com/assets/storage/20200102/5071c5672ed392e7fdb7ba3ae57a8961/4k_2x.png',
  iLogo4KMb:
    'https://static.insta360.com/assets/storage/20200102/0b7d297f70d8eb930087806ee6146ed1/ONE_R_4K_360_m_2x.png',
  iLogoLaica: 'https://static.insta360.com/assets/storage/20200102/f3011d83ec8ab757558d46fdc95febe2/laica.png',
  iLogoLaicaMb:
    'https://static.insta360.com/assets/storage/20200102/aa828eaa1b0d8363de0fca547cb6a268/ONE_R_1_Inch_editon_m_2x.png',
  iRightGray:
    'https://static.insta360.com/assets/storage/20200103/b3e3aeeeb6778c4914709afd83b4c5aa/arrow2_right_2x.png',
  iLeftBlack24: 'https://static.insta360.com/assets/storage/20200106/ad50282fe3f167e2e6011b64a021b1c7/iLeftBlack24.png',
  iRightBlack24:
    'https://static.insta360.com/assets/storage/20200106/c18c64756fa797f394fc35baadf2f8fb/iRightBlack24.png',
};

export default {
  getList,
  enabled,
  getOrdinalNumberText,
  ic,
};
